function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import * as actions from '../../actions/marginHistoryActions';
import { distinct } from '../../../helpers/arrayHelper';
var initialState = {
  openPositions: [],
  closedPositions: [],
  positionPayments: [],
  activeRequests: 0
};
export var marginHistoryReducer = function marginHistoryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case actions.REQUEST_OPEN_POSITIONS:
    case actions.REQUEST_CLOSED_POSITIONS:
    case actions.REQUEST_MARGIN_POSITIONS_PAYMENTS:
      return Object.assign({}, state, {
        activeRequests: ++state.activeRequests
      });
    case actions.RECEIVE_OPEN_POSITIONS:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        openPositions: payload
      });
    case actions.RECEIVE_CLOSED_POSITIONS:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        closedPositions: payload
      });
    case actions.RECEIVE_MARGIN_POSITIONS_PAYMENTS:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        positionPayments: payload
      });
    case actions.ADD_OPEN_POSITION:
      return Object.assign({}, state, {
        openPositions: distinct([payload].concat(_toConsumableArray(state.openPositions)), function (position) {
          return position.PositionId;
        })
      });
    case actions.ADD_CLOSED_POSITION:
      return Object.assign({}, state, {
        closedPositions: distinct([payload].concat(_toConsumableArray(state.closedPositions)), function (position) {
          return position.PositionId;
        }),
        /**
         * Note: back-end may temporarily set position.Status to e.g. `InClosingWithMarketOnly`.
         *  This is technically a `MarginPositionStatusQuery` = 1 (NotClose).
         */
        openPositions: state.openPositions.filter(function (i) {
          return i.PositionId !== payload.PositionId;
        })
      });
    case actions.RECEIVE_MARGIN_POSITION_PAYMENTS_EVENT:
      return Object.assign({}, state, {
        positionPayments: distinct([payload].concat(_toConsumableArray(state.positionPayments)), function (positionPayment) {
          return positionPayment.PositionPaymentId;
        })
      });
    case actions.REMOVE_MARGIN_HISTORY_ACTIVE_REQUEST:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests
      });
    default:
      return state;
  }
};